import UnityEnvironment from '../core/Components/Environments/UnityEnvironment';
import GameManager from '../core/GameManager';
import Tools from '../core/Misc/Tools';
import $ from 'jquery';

export const createUnityVisualizerInstance = (gameManager: GameManager) => {
	return new UnityEnvironment(gameManager, 'static/unity-build/index.html',  false, {
		width: 1920,
		height: 1080
	});
};

export const focusFirstElement = (callbackFunc: any) => {
	setTimeout(() => {
		callbackFunc({
			keyCode: 9,
			target: document.activeElement,
			preventDefault: () => {}	
		});
	}, 500);
}

export const filterTextForJaws = (text: string) => {
	return text.replace('911', '9 1 1');
}

export const updateElementFocus = (e: any, focusable: any, parentOfFocus?: any) => {
	if (focusable.length) {
		let first = focusable[0] as HTMLElement;
		let last = focusable[focusable.length - 1] as HTMLElement;
		let shift = e.shiftKey;
		if (shift) {
			if (e.target === first) { // shift-tab pressed on first input in dialog
				last.focus();
				e.preventDefault();
			}
		} else {
			if (e.target === last) { // tab pressed on last input in dialog
				first.focus();
				e.preventDefault();
			}
		}

		var found = false;

		if(parentOfFocus) {
			var $parents = $(e.target).parents();
			for(var i = 0; i < $parents.length; i++) {
				if($parents.get(i) === parentOfFocus) {
					found = true;
					break;
				}
			}
		} else {
			for(var i = 0; i < focusable.length; i++) {
				if(focusable[i] === e.target) {
					found = true;
					break;
				}
			}
		}
		
		if(!found) {
			first.focus();
			e.preventDefault();
		}
	}
}

export var isios = (): boolean => {
	return [
		'iPad Simulator',
		'iPhone Simulator',
		'iPod Simulator',
		'iPad',
		'iPhone',
		'iPod'
	  ].includes(navigator.platform)
	  // iPad on iOS 13 detection
	  || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}

export var constants = {
	InGameUINames: {
		Assessment: 'Assessment',
		BinaryQuestion: 'BinaryQuestion',
		BleedingControlKit: 'BleedingControlKit',
		BleedoutTimer: 'BleedoutTimer',
		Feedback: 'Feedback',
		ApplyPPE: 'ApplyPPE',
		ApplyPressure: 'ApplyPressure',
		Call911: 'Call911',
		RotateCamera: 'RotateCamera',
		LookAtObject: 'LookAtObject',
		LookAtObjectTutorial: 'LookAtObjectTutorial',
		TourniquetePlacement: 'TourniquetePlacement',
		TourniqueteRotation: 'TourniqueteRotation',
		PauseMenu: 'PauseMenu',
		PauseMenuTutorial: 'PauseMenuTutorial',
		Aar: 'Aar',
		Start: 'Start',
		ScenarioStart: 'ScenarioStart',
		BackToMainMenu: 'BackToMainMenu',
		EmsContainer: 'EmsContainer',
		GenericModal: 'GenericModal'
	},
	placementType: {
		wrong: 1,
		close: 2,
		correct1: 3,
		correct2: 4
	}
};

export interface ILaunchedScenario {
	active: number,
	next: number,
	isCompleted: boolean,
	isPractive: boolean

}

export class Globals {
	static showCorrectPath: boolean;
	static stopTimer: boolean;
	static markCurrentScenarioAsCompleted: boolean;
	static skipAnimations: boolean;
}
export var launchedScenarioStore = 'launchedScenario-BC';